import { render, staticRenderFns } from "./dialog-add-collect.vue?vue&type=template&id=5e4f7844&scoped=true"
import script from "./dialog-add-collect.vue?vue&type=script&lang=js"
export * from "./dialog-add-collect.vue?vue&type=script&lang=js"
import style0 from "./dialog-add-collect.vue?vue&type=style&index=0&id=5e4f7844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f7844",
  null
  
)

export default component.exports